<template>
<div>
  <TriangleHeader :title="$t('register')"/>
  <v-form
      :style="$vuetify.breakpoint.mdAndUp?'width:500px':'fit-content'"
      class="auth-box" lazy-validation v-model="valid"
          ref="form">
    <v-row class="mx-auto mt-16">
      <v-col v-for="(item,index) in formItems" :key="index"  :cols="item.type==='row'|| $vuetify.breakpoint.smAndDown?12:6" class="px-4">
        <p v-if="item.type!=='row'" dir="auto">{{$t(item.label)}}</p>
        <div dir="auto" class="d-flex align-center mb-4" v-if="item.type==='row'">

         <v-row class="mt-4">
           <v-col>
             <p class="mb-2" dir="auto">{{$t('catalogue')}}</p>
             <input type="file"  @change=uploadCatalogue>
           </v-col>
           <v-col>
             <p class="mb-2" dir="auto">{{$t('customers_list')}}</p>
             <input type="file"  @change=uploadCustomerList>
           </v-col>
         </v-row>
        </div>
        <v-text-field
            v-else
            :rules="item.required?textRules:''"
            outlined
            dense
            v-model="item.value"
        ></v-text-field>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-btn color="warning"
             depressed
             :loading="loading"
             @click="register"
             width="200"
             class="mb-16 mt-4">
        <p style="color: #25458c">ثبت نام</p>
      </v-btn>
    </div>
  </v-form>
  <p class="text-center">قبلا ثبت نام کرده اید؟ <router-link to="/login">اینجا</router-link> کلیک کنید</p>
  <v-snackbar
      :value="error"
      color="warning"
  >
    <p dir="auto" class="snackbar-text">{{$t('wrong_register')}}</p>
  </v-snackbar>
</div>
</template>

<script>
import TriangleHeader from "../../components/triangle_header/TriangleHeader";
import {REGISTER_USER} from "../../store/authManagement/action_type";
import loading from "../../components/loading/loading";
export default {
  name: "register",
  components: {TriangleHeader},
  data(){
    return{
      loading:false,
      valid:false,
      error:false,
      textRules: [
        v => !!v || 'field is required',
      ],
      formItems:[
        {
          label:'comapny_name',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'register_number',
          value:'',
          type:'',
          required:false,
        },
        {
          label:'melicode',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'register_location',
          value:'',
          type:'',
          required:false,
        },
        {
          label:'eco_code',
          value:'',
          type:'',
          required:false,
        },
        {
          label:'personal_code',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'export_license',
          value:'',
          type:'',
          required:false,
        },
        {
          label:'work_field',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'experience',
          value:'',
          type:'',
          required:false,
        },
        {
          label:'referrer',
          value:'',
          type:'',
          required:false,
        },
        {
          label:'address',
          value:'',
          type:'',
          required:false,
        },
        {
          label:'province_id',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'city_id',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'postcode',
          value:'',
          type:'',
          required:false,
        },
        {
          label:'description',
          value:'',
          type:'',
          required:false,
        },
        {
          label:'manager_name',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'manager_tel',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'manager_email',
          value:'',
          type:'',
          required:false,
        },
        {
          label:'trade_agent_name',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'trade_agent_tel',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'trade_agent_email',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'tel',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'fax',
          value:'',
          type:'',
          required:false,
        },
        {
          label:'company_email',
          value:'',
          type:'',
          required:true,
        },
        {
          label:'',
          value:'',
          type:'row',
          required:false,
        },

      ],
      catalogue:'',
      customerList:'',
    }
  },
  methods:{
    uploadCatalogue(e){
      console.log(e);
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e =>{
        this.catalogue = e.target.result;
        console.log("file", this.catalogue);
      };
    },
    uploadCustomerList(e){
      console.log(e);
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e =>{
        this.customerList = e.target.result;
        console.log("file", this.customerList);
      };
    },
    register(){
      if (this.$refs.form.validate()){
        if(this.catalogue.length>0&&this.customerList.length>0){
          this.loading=true;
          var data =new FormData();
          for (let i =0; i<this.formItems.length;i++){
            var item = this.formItems[i];
            if (item.type!=='row'){
              data.append(item.label,item.model)
            }
          }

          data.append('catalogue',this.catalogue);
          data.append('customerList',this.customerList);
          data.api_key = '402784613679330';
          this.$store.dispatch(`authManagement/${REGISTER_USER}`,data).then(
              ()=> {
                this.loading = false;
                this.$router.go(-2);
              }
          );
        }else{
          this.error=true;
        }
      }
    },
  }
}
</script>

<style scoped>

</style>